import { useQueryClient } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { io } from 'socket.io-client';
import { apiOrigin, tokenStore } from './api';

/**
 * Tempo real do módulo Vendas: a API avisa `sales.proposal.changed` só para quem pode
 * ver a proposta, e a tela relê pela API (que aplica o escopo). Devolve se está ligado.
 */
export function useSalesRealtime(): boolean {
  const queryClient = useQueryClient();
  const [online, setOnline] = useState(false);

  useEffect(() => {
    const socket = io(`${apiOrigin()}/realtime`, {
      auth: (callback) => callback({ token: tokenStore.access ?? '' }),
      transports: ['websocket'],
    });
    socket.on('ready', () => setOnline(true));
    socket.on('disconnect', () => setOnline(false));
    socket.on('sales.proposal.changed', () => {
      void queryClient.invalidateQueries({ queryKey: ['sales'] });
    });
    return () => {
      socket.disconnect();
    };
  }, [queryClient]);

  return online;
}
